import { GetSellerInsightsPhotoRecommendationsResp } from 'types/api/response/get-seller-insights-photo-recommendations-resp'

import { api } from './api'

export const getSellerInsightsPhotoRecommendations = () =>
  api.get<GetSellerInsightsPhotoRecommendationsResp>('/seller_insights/recommendations/add_photos')
